module.exports = "<flot *ngIf=\"dataset.length > 0\" [options]=\"options\" [dataset]=\"dataset\" height=\"550px\" width=\"100%\"></flot>"


//////////////////
// WEBPACK FOOTER
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/src/app/fusionbar/fusionbar.component.html
// module id = ../../../../../src/app/fusionbar/fusionbar.component.html
// module chunks = 0